import styled from 'styled-components'
import { flexDirection, margin } from 'styled-system'
import themeGet from '@styled-system/theme-get'

import { Icon } from 'Components/UI/_Legacy'
import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

import sendGlyph from 'Assets/_Legacy/Svg/send.svg'

import { gap } from 'Services/Styles'

const shouldForwardProp = prop => {
  return !DIV_SHOULD_FORWARD_PROP.includes(String(prop))
}

export const Container = styled.div`
  width: 100%;
  align-items: center;
  justify-content: center;
`

export const SendIcon = styled(Icon).attrs({
  size: 16,
  glyph: sendGlyph,
})`
  margin-right: 12px;
  fill: ${themeGet('colors.white')};
`

export const FormContainer = styled.div`
  width: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const Row = styled.div.withConfig({
  shouldForwardProp,
})`
  display: flex;
  width: 100%;

  ${flexDirection}
  ${margin}
  ${gap}
`
